import React, { useEffect } from "react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "../../../../components/ui/dropdown-menu";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "../../../../components/ui/tooltip";
import type { GoogleDriveSession } from "../../hooks/useFileSelectionHandlers";
import { preloadGoogleDrive } from "../../../../libs/google-drive";

interface GoogleDriveButtonProps {
  session: GoogleDriveSession;
  onPick: () => void | Promise<void>;
  onSwitchAccount: () => void | Promise<void>;
  tooltip?: React.ReactNode;
  children: React.ReactElement<{ onClick?: React.MouseEventHandler }>;
}

export const GoogleDriveButton = ({
  session,
  onPick,
  onSwitchAccount,
  tooltip,
  children,
}: GoogleDriveButtonProps) => {
  useEffect(() => {
    preloadGoogleDrive();
  }, []);

  const pick = () => {
    void onPick();
  };

  if (!session.active) {
    const button = React.cloneElement(children, { onClick: pick });

    return tooltip ? (
      <Tooltip>
        <TooltipTrigger asChild>{button}</TooltipTrigger>
        <TooltipContent>{tooltip}</TooltipContent>
      </Tooltip>
    ) : (
      button
    );
  }

  const trigger = <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>;

  return (
    <DropdownMenu>
      {tooltip ? (
        <Tooltip>
          <TooltipTrigger asChild>
            {/* The span takes the tooltip ref, which DropdownMenuTrigger does not forward. */}
            <span className="inline-flex shrink-0">{trigger}</span>
          </TooltipTrigger>
          <TooltipContent>{tooltip}</TooltipContent>
        </Tooltip>
      ) : (
        trigger
      )}
      <DropdownMenuContent align="start">
        {session.email && (
          <DropdownMenuLabel className="text-xs font-normal text-neutral-500">
            {session.email}
          </DropdownMenuLabel>
        )}
        <DropdownMenuItem onSelect={pick}>
          Choose from Google Drive
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={() => {
            void onSwitchAccount();
          }}
        >
          Use a different Google account
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
